import { emptySplitApi } from "./empty-split-api";

export interface ICD10Code {
  id: number;
  code: string;
  description: string;
  is_active?: boolean;
}

type ICD10CodesResponse = ICD10Code[];

const extendedIcdCodesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getICD10Codes: builder.query<
      ICD10CodesResponse,
      { search?: string; is_active?: boolean; code?: string; limit?: number }
    >({
      query: (params) => ({
        url: `icd10-codes/`,
        params: {
          limit: 300,
          ...params,
          search: params.search ? encodeURIComponent(params.search) : undefined
        }
      }),
      providesTags: ["ICD10Codes"]
    }),
    // The billable codes beneath a heading code (H61.2 -> H61.20..H61.23): what to
    // pick instead of it once the heading is inactive. Empty for a leaf code.
    getICD10CodeReplacements: builder.query<ICD10CodesResponse, number>({
      query: (id) => ({ url: `icd10-codes/${id}/replacements/` }),
      providesTags: ["ICD10Codes"]
    }),
    autoCompleteICD10Codes: builder.mutation<string, { chart_note_id: number }>(
      {
        query: (chartNoteData) => ({
          url: "icd10-codes/complete",
          method: "POST",
          body: chartNoteData
        })
      }
    )
  })
});

export const {
  useGetICD10CodesQuery,
  useGetICD10CodeReplacementsQuery,
  useAutoCompleteICD10CodesMutation
} = extendedIcdCodesApi;
